import { getSiteLocation } from 'aos-config-loader'

import { TaskCategory } from './TaskCategory'

const siteLocations = getSiteLocation()

export const { allowedCategories, allowedSubcategories } = siteLocations.taskConfig as {
    allowedCategories: TaskCategory[]
    allowedSubcategories: Record<TaskCategory, string[]>
}
